import Store from 'store';
import {FULFILLED} from 'redux-promise-middleware';
import {takeLatest, call, put, putResolve, take, select, fork} from 'redux-saga/effects';
import {Rox} from 'rox-ssr';

import {CUSTOMER} from 'constants/actions';
import {BRONTO_CONTACT_EID, BRONTO_MAGENTO_ID} from 'constants/bronto/bronto';
import {isHtoEnabled} from 'constants/flags/flags';
import {getCustomerData, fetchPrescription} from 'actions/customer/customer';
import {getItemsCount} from 'actions/cart/cart';
import {getQuoteItems} from 'actions/checkout/checkout';
import {isCustomerLogged} from 'selectors/customer/customer';
import {getToken, fetchSelf, getCustomer} from 'reducers/oAuth/oAuth';

/**
 * Get current status of user (logged or not)
 * And also returns data about the user, when there is brontoId and subsciberId
 */
export function* getCustomerSaga() {
    const brontoId = yield call([Store, 'get'], BRONTO_CONTACT_EID);
    const subsciberId = yield call([Store, 'get'], BRONTO_MAGENTO_ID);

    const customer = yield call(getCustomerData, brontoId, subsciberId);
    yield putResolve(customer);
}

/**
 * Fetches the last customer prescription.
 */
export function* fetchSavedPrescription() {
    const isLogged = yield select(isCustomerLogged);

    if (isLogged) {
        yield put(fetchPrescription());
    }
}

/**
 * Sets email to rollout
 */
export function* setCustomerEmailToRollout() {
    const customer = yield select(getCustomer);
    yield call([Rox, 'setCustomStringProperty'], 'email', customer.email);
}

/**
 * Sets hto prop to rollout
 * @param {Object} action - optional, if we call it on login it will be defined
 */
export function* setHtoToRollout(action = null) {
    const {htoExperience, isLoggedIn} = yield select(getCustomer);
    if (isLoggedIn) {
        const isHto = isHtoEnabled();
        yield call([Rox, 'setCustomBooleanProperty'], 'isHto', Boolean(htoExperience));
        if (Boolean(action) && !isHto && Boolean(htoExperience)) {
            window.location.reload(); // todo GUSA-12906cd Mary sad solution, we do not see rerendered hto experience
        }
    }
}

/**
 * Handles CUSTOMER.SEND_LOGIN_FULFILLED action
 */
export function* onCustomerLogIn() {
    yield take(`${fetchSelf}_${FULFILLED}`);
    yield put(getItemsCount()); // TODO Matyushkin - in the future, this request should be replaced with getQuoteItems
    yield put(getQuoteItems());
}

/**
 * Start customer saga
 */
export default function* customerSaga() {
    yield fork(getCustomerSaga);
    yield call(setCustomerEmailToRollout);
    yield call(setHtoToRollout);
    yield takeLatest(`${CUSTOMER.GET_CUSTOMER_DATA}_FULFILLED`, fetchSavedPrescription);
    yield takeLatest(`${CUSTOMER.GET_CUSTOMER_DATA}_FULFILLED`, setCustomerEmailToRollout);
    yield takeLatest(`${fetchSelf}_${FULFILLED}`, setHtoToRollout);
    yield takeLatest(getToken, onCustomerLogIn);
}
